import "./style.scss";
import * as React from "react";
import * as utils from "../../../common";
import _ from "lodash";
import {
  BarChart,
  Bar,
  Brush as reBrush,
  XAxis,
  YAxis,
  CartesianGrid,
  CartesianAxis,
  Tooltip as reTooltip,
  Text,
  ResponsiveContainer,
  Legend
} from "recharts";
import { AxisLabel, AxisTick, Legend as LegendContents } from "../../common";
import { Tooltip as TooltipContents } from "../../../common/Tooltip";

const Brush: any = reBrush;
const Tooltip: any = reTooltip;

export default class SimpleBarChart extends React.Component<
  SimpleBarChartProps,
  any
> {
  constructor() {
    super();
    this.state = {
      xAxisTickInterval: 0
    };
  }

  renderBars() {
    if (this.props.chartProps != null && this.props.chartProps.data != null) {
      let stackId = this.props.chartProps.stacked ? "stacked" : null;
      let valueKeys: string[] = [];
      let bars: any = [];

      this.props.chartProps.data.forEach((entry: any) => {
        valueKeys.push(
          ...Object.keys(entry).filter(
            (key: string) =>
              key.toLowerCase() !=
              this.props.chartProps.groupingKey.toLowerCase()
          )
        );
      });
      valueKeys = _.uniq(valueKeys);
      valueKeys.forEach((key, index) => {
        bars.push(
          <Bar
            key={index}
            maxBarSize={400}
            dataKey={key}
            fill={`#${utils.CHART_COLORS[index % utils.CHART_COLORS.length].toString(16)}`}
            stackId={stackId}
            onClick={this.props.handleBarClick}
          />
        );
      }, this);
      return bars;
    }
  }

  renderTooltip() {
    let {
      chartProps: { data, valueKey, groupingKey }
    } = this.props;
    return (
      <Tooltip
        content={
          <TooltipContents
            valueKey={valueKey}
            groupingKey={groupingKey}
            filterNull={false}
          />
        }
      />
    );
  }

  handleBrushChange = (event: any) => {
    // Calculate how many axis ticks to show based on the
    // number of bars now visibile in the graph
    const { startIndex, endIndex } = event;
    const visibleBars = endIndex - startIndex + 1;
    const newInterval = Math.floor(visibleBars / 12);
    if (newInterval != this.state.xAxisTickInterval)
      this.setState({ xAxisTickInterval: newInterval });

    // Do other things
    this.props.onBrushChange();
  };

  render() {
    //NOTE: the order of child components matter, render items on top last

    const {
      xAxisProps: { labelProps: xLabelProps, tickProps: xTickProps },
      yAxisProps: { labelProps: yLabelProps, tickProps: yTickProps },
      chartProps: { data },
      initialZoom
    } = this.props;

    if (!data || data.length == 0) {
      return <div />;
    } else {
      return (
        <div className="bar-chart" style={{ width: "100%", height: "100%" }}>
          <ResponsiveContainer {...this.props.containerProps}>
            <BarChart
              {...this.props.chartProps}
              margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
            >
              <XAxis
                height={70}
                interval={this.state.xAxisTickInterval}
                label={<AxisLabel {...xLabelProps} dy={5} />}
                tickLine={false}
                tick={
                  <AxisTick
                    {...xTickProps}
                    interval={this.state.xAxisTickInterval}
                  />
                }
                dataKey={this.props.chartProps.groupingKey}
              />
              <YAxis
                type="number"
                allowDecimals={true}
                allowDataOverflow={true}
                interval={0}
                label={<AxisLabel {...yLabelProps} />}
                tick={<AxisTick {...yTickProps} />}
                tickLine={false}
                axisLine={false}
                tickCount={4}
              />
              <CartesianGrid vertical={false} strokeDasharray="3 3" />
              {this.renderTooltip()}
              {this.renderBars()}
              {this.props.chartProps.compareKey ? (
                <Legend
                  verticalAlign="top"
                  align="center"
                  wrapperStyle={{ top: 0 }}
                  content={
                    <LegendContents
                      compareKey={this.props.chartProps.compareKey}
                    />
                  }
                />
              ) : null}
              {this.props.disableBrush ? null : (
                <Brush
                  fill="#F5F7FB"
                  stroke="#C4CCE3"
                  dataKey={this.props.chartProps.groupingKey}
                  data={this.props.chartProps.data}
                  startIndex={initialZoom ? initialZoom.startIndex : null}
                  endIndex={initialZoom ? initialZoom.endIndex : null}
                  onChange={this.handleBrushChange}
                >
                  <BarChart>
                    <Text textAnchor="start" verticalAnchor="start">
                      DRAG TO ZOOM
                    </Text>
                    {this.renderBars()}
                  </BarChart>
                </Brush>
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/CartesianChart/BarChart/SimpleBarChart/index.tsx